import React from "react";
import GalleryFilterContext from "./context";

function useGalleryFilters() {
  const context = React.useContext(GalleryFilterContext);

  if (!context) {
    throw new Error("Must be used within GalleryFilterProvider");
  }

  return context;
}

export default useGalleryFilters;
